import { requestWithToken } from '../utilities/request';
const path = '/api/private';

const list = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/report_settings/list`),
    params: param,
  });
};

const outputSetting = param => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/report_settings/output_setting`),
    params: param,
  });
};

export const ReportSettingService = {
  list,
  outputSetting,
};
export default ReportSettingService;



// WEBPACK FOOTER //
// ./src/services/ReportSettings.js